import React, { useEffect } from 'react';

import { SaviSuggestions } from '../../components';
import { IspmErrorProvider } from '../../context/ispmErrorContext';
import { Logger } from '../../services';
import { DASHBOARD_BODY } from '../../tests/testids';
import {
  hideHostAppElements,
  hideHostAppElementsCleanup,
  removeDynamicBodyClasses,
} from '../../utils/hideHostElements';

import ChatOrDashboard from './index';

import './Dashboard.css';

/**
 * Dashboard Component
 *
 * contains Apache superset dashboard and Chat overlay
 * @returns
 */
function Dashboard() {
  Logger.info('Loading Insight Dashboard');

  useEffect(() => {
    /* hide host app elements not needed for Gen2 UI */
    hideHostAppElements();
    removeDynamicBodyClasses();

    return () => {
      hideHostAppElementsCleanup();
    };
  }, []);

  return (
    <section className='Ispm-dashboardContainer'>
      <IspmErrorProvider>
        <SaviSuggestions testId={DASHBOARD_BODY} />
        <ChatOrDashboard testId={DASHBOARD_BODY} />
      </IspmErrorProvider>
    </section>
  );
}

export default Dashboard;
